import { Button, Result } from "antd";
import React from "react";

const Error = () => (
  <Result
    status="404"
    title="404"
    subTitle="Sorry, the page you visited does not exist."
    extra={
      <Button type="primary" href="/dashboard">
        Back Dashboard
      </Button>
    }
  />
);

export default Error;
